// approvalFlow.action.ts
import {
  ApprovalFlowDetailsData,
  ApprovalFlowGetData,
  ApprovalLevels,
} from "../model/approvalsFlowModel";
export type FlowDialogMode = "create" | "edit" | "view";
export type ApprovalFlowAction =
  | { type: "SET_NAME"; payload: string }
  | { type: "SET_LEVELS"; payload: ApprovalLevels[] }
  | { type: "SET_DETAILS_LEVELS"; payload: ApprovalLevels[] }
  | { type: "SET_APPROVALS"; payload: ApprovalFlowGetData[] }
  | { type: "SET_IS_DEFAULT"; payload: boolean }
  | { type: "SET_NUM_LEVELS"; payload: number }
  | {
      type: "SET_ACTIVE_TAB";
      payload:
        | "Approval Flow"
        | "Pool Names"
        | "Subscription"
        | "Credit Usage"
        | "Credit Alerts";
    }
  | { type: "UPDATE_LEVEL"; id: string; updates: Partial<ApprovalLevels> }
  | { type: "RESET" }
  | { type: "SET_EDITING_FLOW"; payload: ApprovalFlowGetData | undefined }
  | { type: "SET_FLOW_DIALOG_OPEN"; payload: boolean }
  | { type: "SET_DETAILED_APPROVALS"; payload: ApprovalFlowDetailsData }
  | { type: "SET_DIALOG_MODE"; payload: FlowDialogMode }
  | {
      type: "SET_TOAST";
      payload: {
        isVisible: boolean;
        message: string;
        type: "success" | "error" | "warning" | "info";
      };
    }
  | { type: "SET_LOADING"; payload: boolean }
  | { type: "HIDE_TOAST" }
  | { type: "SET_LOADING"; payload: boolean }
  | { type: "OPEN_DELETE_DIALOG"; payload: string }
  | { type: "CLOSE_DELETE_DIALOG" }
 
  | { type: "SET_LIST_LOADING"; payload: boolean };

export const setListLoading = (payload: boolean): ApprovalFlowAction => ({
  type: "SET_LIST_LOADING",
  payload,
});

export const setApprovalFlowName = (name: string): ApprovalFlowAction => ({
  type: "SET_NAME",
  payload: name,
});
export const setLoading = (payload: boolean): ApprovalFlowAction => ({
  type: "SET_LOADING",
  payload,
});
export const setApprovals = (payload: any[]): ApprovalFlowAction => ({
  type: "SET_APPROVALS",
  payload,
});
export const setActiveTab = (
  payload:
    | "Approval Flow"
    | "Pool Names"
    | "Subscription"
    | "Credit Usage"
    | "Credit Alerts",
): ApprovalFlowAction => ({
  type: "SET_ACTIVE_TAB",
  payload,
});
export const setDetailedApprovals = (
  payload: ApprovalFlowDetailsData,
): ApprovalFlowAction => ({
  type: "SET_DETAILED_APPROVALS",
  payload,
});
export const setDialogMode = (payload: FlowDialogMode): ApprovalFlowAction => ({
  type: "SET_DIALOG_MODE",
  payload,
});
export const setApprovalFlowLevels = (
  levels: ApprovalLevels[],
): ApprovalFlowAction => ({
  type: "SET_LEVELS",
  payload: levels,
});
export const setApprovalDetailsLevels = (
  levels: ApprovalLevels[],
): ApprovalFlowAction => ({
  type: "SET_DETAILS_LEVELS",
  payload: levels,
});

export const setApprovalFlowIsDefault = (
  isDefault: boolean,
): ApprovalFlowAction => ({
  type: "SET_IS_DEFAULT",
  payload: isDefault,
});

export const setApprovalFlowNumLevels = (
  numLevels: number,
): ApprovalFlowAction => ({
  type: "SET_NUM_LEVELS",
  payload: numLevels,
});

export const updateApprovalLevel = (
  id: string,
  updates: Partial<ApprovalLevels>,
): ApprovalFlowAction => ({
  type: "UPDATE_LEVEL",
  id,
  updates,
});

export const resetApprovalFlow = (): ApprovalFlowAction => ({
  type: "RESET",
});
export const setToast = (payload: {
  isVisible: boolean;
  message: string;
  type: "success" | "error" | "warning" | "info";
}): ApprovalFlowAction => ({
  type: "SET_TOAST",
  payload,
});

export const hideToast = (): ApprovalFlowAction => ({
  type: "HIDE_TOAST",
});
